import axios from 'axios';
import { FormValues } from '../tickets/types';
import { Dispatch } from 'react';
import { Languages } from '~/components/LanguageSelector';
import { setError } from '~/GlobalRedux/Features/error/errorSlice';
import { AnyAction } from '@reduxjs/toolkit';
import { setSuccess } from '~/GlobalRedux/Features/success/successSlice';
import { API_BASE_URL } from '../variables';
import { initialFormValue } from '../texts';
import { setLoading } from '~/GlobalRedux/Features/loading/loadingSlice';

const postTicket = async (data: any, file: any, dispatch: Dispatch<AnyAction>, setFormValue: (value: FormValues) => void) => {
  
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
  });
  if (file) {
      formData.append('file', file);
  }

  try {
      const response = await axios.post(`${API_BASE_URL}/api/v1/chamados/`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
              'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_APIM_KEY
          }
      });
      if (response.status < 300) {
        dispatch(setSuccess(true))
        setFormValue(initialFormValue)
        dispatch(setLoading(false))
        window.scrollTo({ top: 0 })
      }
      return response.data;
  } catch (error) {
    window.scrollTo({ top: 0 })
    dispatch(setError(true));
    dispatch(setLoading(false))
    console.error("Erro ao enviar o ticket", error);
  }
};

export const handleSubmitForm = async (
  formValues: FormValues,
  isButtonEnabled: boolean,
  setWarning: (state: boolean) => void,
  dispatch: Dispatch<AnyAction>,
  setFormValue: (value: FormValues) => void,
  language: Languages,
) => {
  if (!isButtonEnabled) {
    setWarning(true);
  } else {
    window.scrollTo({ top: 0 })
    dispatch(setLoading(true))
    setWarning(false);
    const newForm = {
      pedido: formValues.request,
      detalhes: formValues.requestDetail,
      quem_solicitou: formValues.iAm,
      relacao: formValues.relation,
      nome: formValues.fullName,
      numero_celular: formValues.cellNumber,
      email: formValues.eMail,
      autorizacao: formValues.authorize ? 'True' : 'False',
      idioma: language,
      np: formValues.np,
      suzano_mail: formValues.suzano_mail,
      segments: formValues.segments.join(),
      brands: formValues.brands.join(),
      supplier: formValues.supplier,
      corp_mail: formValues.corp_mail,
    };
  
    postTicket(newForm, formValues.photo, dispatch, setFormValue)
  }
};
